module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f5fe7b4329c7728162f3383154c25b4f.png";